export default __webpack_public_path__ + "static/kb_2_2-7a72d11f525802c09deb499aecd056bf.jpeg";